export function selectControlRoomData({
  streamReady,
  streamSnapshot,
  fallbackStatus,
  fallbackPositions,
}) {
  const statusFromStream = Boolean(streamReady && streamSnapshot?.status);
  const positionsFromStream = Boolean(
    streamReady && Array.isArray(streamSnapshot?.positions),
  );

  return {
    status: statusFromStream ? streamSnapshot.status : fallbackStatus,
    positions: positionsFromStream ? streamSnapshot.positions : fallbackPositions,
    statusFromStream,
    positionsFromStream,
  };
}
